import React, { useState } from 'react';
// import CryptoJS from 'crypto-js';
import './Razor.css';

const RazorpayPayment = ({ 
  appId = "389", 
  userId = "710", 
  amount = 50000, 
  currency = 'INR',
  onPaymentStatusChange = () => {},
  onBack = () => {} 
}) => {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const org_name= localStorage.getItem('org_name')
  const razorpay_key= localStorage.getItem('razorpay_key')
  console.log(appId,userId,amount,currency,org_name,razorpay_key);
  
  const CONFIG = {
    API_ENDPOINT: 'https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/payment',
    RAZORPAY_KEY: razorpay_key,
    RAZORPAY_SECRET: '',
    COMPANY_NAME: org_name,
    CONTACT_DETAILS: {
      name: 'Customer Name',
      email: 'dy81114@gmail.com',
      phone: '6392178640'
    }
  };
  
  const getAccessToken = () => {
    try {
      const accessToken = localStorage.getItem('access_token');
      if (!accessToken) {
        throw new Error('Authentication required');
      }
      return accessToken;
    } catch (error) {
      console.error('Token retrieval error:', error);
      setError('Please log in again');
      return null;
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve, reject) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => reject(new Error('Razorpay SDK failed to load'));

      document.body.appendChild(script);
    });
  };

  const createPaymentRecord = async (paymentData) => {
    const accessToken = getAccessToken();
    if (!accessToken) return;

    try {
      const payload = {
        appid: appId,
        userid: userId,
        payment_amount:amount/100,
        payment_token: paymentData.paymentId || "pending",
        payment_status: paymentData.status,
        payment_datetime: paymentData.timestamp,
        remarks: paymentData.status === 'success' 
          ? "Payment processed successfully" 
          : `Payment ${paymentData.status}: ${paymentData.reason || 'Unknown reason'}`
      };
      console.log(payload);
      
      const response = await fetch(CONFIG.API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const dev = await response.text()
        console.log(dev);
        
        throw new Error(`Payment record creation failed: ${response.status}`);
      }

      const result = await response.json();
      console.log(result);
      
      // Update payment status with API response
      setPaymentStatus(prevStatus => ({
        ...prevStatus,
        apiResponse: result
      }));

      return result;
    } catch (error) {
      console.error('Payment record creation error:', error);
      setError(error.message);
      
      // Update payment status with error
      setPaymentStatus(prevStatus => ({
        ...prevStatus,
        apiError: error.message
      }));

      return null;
    }
  };

  const displayRazorpay = async () => {
    setLoading(true);
    setError(null);

    try {
      await loadRazorpayScript();
      
      const options = {
        key: CONFIG.RAZORPAY_KEY,
        amount: amount,
        currency: currency,
        name: CONFIG.COMPANY_NAME,
        description: 'Test Transaction',
        handler: async (response) => {
          const paymentData = {
            paymentId: response.razorpay_payment_id,
            orderId: response.razorpay_order_id,
            signature: response.razorpay_signature,
            status: 'success',
            timestamp: new Date().toISOString(),
            reason: null
          };
          onPaymentStatusChange(paymentData);
          // Create payment record in the backend
          await createPaymentRecord(paymentData);
          
          // Update payment status
          setPaymentStatus(paymentData);
          setLoading(false);
        },
        prefill: {
          name: CONFIG.CONTACT_DETAILS.name,
          email: CONFIG.CONTACT_DETAILS.email,
          contact: CONFIG.CONTACT_DETAILS.phone
        },
        notes: {
          address: 'Your Company Address',
          userId: userId,
          appId: appId
        },
        theme: {
          color: '#3399cc'
        }
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on('payment.failed', async (response) => {
        const paymentData = {
          status: 'failed',
          reason: response.error.reason,
          timestamp: new Date().toISOString()
        };
        onPaymentStatusChange(paymentData);
        // Create payment record for failed payment
        await createPaymentRecord(paymentData);
        
        setPaymentStatus(paymentData);
        setLoading(false);
      });
    } catch (error) {
      console.error('Payment initialization error:', error);
      setError(error.message);
      setLoading(false);
    }
  };

  // Check if payment is successful
  const isPaymentSuccessful = paymentStatus && paymentStatus.status === 'success';

  return (
    <div className="razorpay-container" style={{ 
      fontFamily: 'Arial, sans-serif',
      maxWidth: '550px',
      margin: '0 auto',
      padding: '10px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#ffffff'
    }}>
      {isPaymentSuccessful ? (
        // Thank you page after successful payment
        <div className="thank-you-container" style={{
          textAlign: 'center',
          padding: '2px'
        }}>
          <div style={{
    width: '80px',
    height: '80px',
    margin: '0 auto 20px',
    borderRadius: '50%',
    backgroundColor: '#4CAF50',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: 'bounce 1.5s infinite',
  }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="white"/>
            </svg>
          </div>
          
          <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '10px' }}>Thank You!</h2>
          <p style={{ color: '#666', fontSize: '16px', marginBottom: '20px' }}>
            Your payment has been processed successfully.
          </p>
          
          <div className="payment-details" style={{ 
            backgroundColor: '#f9f9f9',
            padding: '15px',
            
            borderRadius: '6px',
            marginBottom: '20px',
            textAlign: 'left'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ color: '#666' }}>Amount Paid:</span>
              <span style={{ fontWeight: 'bold',color: '#6c5ce7' }}>₹{amount/100}</span>
            </div>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ color: '#666' }}>Payment ID:</span>
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{paymentStatus.paymentId}</span>
            </div> */}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: '#666' }}>Date:</span>
              <span style={{color: '#6c5ce7'}}>{new Date(paymentStatus.timestamp).toLocaleString()}</span>
            </div>
          </div>
          
          <button 
  onClick={() => {
    const backUrl = localStorage.getItem('ret_endpoint');
    if (backUrl) {
   
      const fullUrl = backUrl.includes('://') ? backUrl : `https://${backUrl}`;
      window.location.href = fullUrl;
    }
  }}
  style={{ 
    padding: '10px 24px', 
    backgroundColor: '#6c5ce7',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.3s'
  }}
  onMouseOver={(e) => e.target.style.backgroundColor = '#6c5ce7'}
  onMouseOut={(e) => e.target.style.backgroundColor = '#6c5ce7'}
>
  Back to Website
</button>
        </div>
      ) : (
        // Payment form
        <>
          <h2 style={{ 
            color: '#333', 
            textAlign: 'center',
            marginBottom: '20px',
            fontSize: '22px'
          }}>Complete Your Payment</h2>
          
          {error && (
            <div className="error-message" style={{ 
              color: '#e74c3c', 
              margin: '15px 0',
              padding: '10px 15px',
              backgroundColor: '#fdecea',
              borderRadius: '4px',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}
          
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: '#f9f9f9',
            borderRadius: '6px',
            padding: '20px',
            marginBottom: '20px'
          }}>
            <p style={{ color: '#666', marginBottom: '15px' }}>Total Amount</p>
            <h3 style={{ fontSize: '28px', color: '#333', margin: '0 0 20px 0' }}>₹{amount/100}</h3>
            
            <button 
              onClick={displayRazorpay}
              disabled={loading}
              style={{ 
                padding: '12px 30px', 
                backgroundColor: loading ? '#cccccc' : '#6c5ce7',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                width: '100%',
                fontWeight: 'bold',
                transition: 'background-color 0.3s'
              }}
              onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#6c5ce7')}
              onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#6c5ce7')}
            >
              {loading ? 'Processing...' : `Pay Securely`}
            </button>
          </div>
          
          <div style={{ textAlign: 'center', margin: '15px 0' }}>
            <img 
              src="https://cdn.razorpay.com/static/assets/merchant-badge/badge-dark.png" 
              alt="Razorpay Secure" 
              style={{ maxWidth: '150px', opacity: 0.8 }}
            />
          </div>
          
          {paymentStatus && paymentStatus.status !== 'success' && (
            <div className="payment-status" style={{ 
              marginTop: '20px',
              padding: '15px',
              backgroundColor: '#f8f9fa',
              borderRadius: '6px',
              fontSize: '14px'
            }}>
              <h3 style={{ fontSize: '16px', marginBottom: '10px', color: '#333' }}>Payment Information</h3>
              <p><strong>Status:</strong> {paymentStatus.status}</p>
              {paymentStatus.reason && <p><strong>Failure Reason:</strong> {paymentStatus.reason}</p>}
              {paymentStatus.apiError && <p><strong>API Error:</strong> {paymentStatus.apiError}</p>}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RazorpayPayment;